<div class="page-layout simple"> <!-- fusePerfectScrollbar -->
  <div class="toolbar second-level-toolbarflex flex-row justify-between items-center">
    <!--    <particle-dashboard-filter-toolbar [filterKey]="filterKey"></particle-dashboard-filter-toolbar>-->
    <div class="grid-toolbar-buttons-group-container m-l-20 flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="resetReport()"
                  particleAnalytics
                  analyticsCategory="analytics"
                  analyticsAction="reset-Report"
                  [disabled]="(!dataLoaded && !failureResponse) || isDefaultReport"
          >Reset Report
          </button>
          <!--<button mat-button class="orbitax-flat-button m-l-20" (click)="refreashReportService()"
                  particleAnalytics
                  analyticsCategory= "analytics"
                  analyticsAction= "reset-Report"
                  [disabled]="!dataLoaded && !failureResponse"
          >Refresh Report</button>
          <button mat-button class="orbitax-flat-button m-l-20" (click)="openPlaground()"
                  particleAnalytics
                  analyticsCategory= "analytics"
                  analyticsAction= "reset-Report"
                  [disabled]="!dataLoaded"
          >Playground</button>
          <button mat-button class="orbitax-flat-button m-l-20" (click)="printReport()"
                  particleAnalytics
                  analyticsCategory= "analytics"
                  analyticsAction= "reset-Report"
                  [disabled]="!dataLoaded"
          >Print Report</button>-->

        </div>
      </div>
    </div>
    <div class="m-l-auto flex flex-col justify-end items-start">


      <div *ngIf="dataLoaded && isEditable">
        <mat-slide-toggle
          [disabled]="!isEditable"
          [checked]="false"
          (change)="handleChange($event)">
          Filter/Edit View
        </mat-slide-toggle>
      </div>
    </div>
  </div>

  <mat-sidenav-container class="particle-page-content-container">
    <!-- CONTENT -->
    <div class="content">

      <!--<particle-filter-tab [filterKey]="filterKey">

      </particle-filter-tab>-->
      <div *ngIf="!failureResponse" class="analytics-container flex flex-col">
        <div [style.visibility]="dataLoaded?'visible':'hidden'" [style.display]="dataLoaded?'block':'none'"
             #reportsContainer id="reportsContainer" class="main-content">
        </div>
        <div *ngIf="!dataLoaded" class="empty-content flex flex-col justify-center items-center flex-1-0-100">
          <div class="text-container">
            <div class="svg-container" [ngStyle]="loadingPercentage">
              <img
                src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
                alt="">
            </div>
            <h1>Loading...</h1>
            <div class="text">Please wait while we load the data for your chosen period and settings. This may take up
              to 60 seconds depending on the size of the data.
            </div>
            <div class="instruction">You can navigate ITP and access your Orbitax Solutions from the left-hand menu at
              any time.
            </div>
          </div>
        </div>

      </div>
      <div class="empty-content flex flex-col justify-center items-center flex-1-0-100" *ngIf="failureResponse">
        <div class="text-container">

          <div class="svg-container" style="background: linear-gradient(to top, red 100%, #eee 0%);">
            <img
              src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/icon.png"
              alt="">
          </div>
          <h1>Sorry, there was an error...</h1>
          <div class="text">We couldn't load your data as the query exceeded the data limit. Please adjust the settings
            to reduce the size of the query, and try again.
          </div>
        </div>
      </div>

    </div>
    <!-- / CONTENT -->
  </mat-sidenav-container>
</div>
